import { useEffect, useState } from 'react';
import { useScript } from 'usehooks-ts';
import config from './useRecaptcha.config.json';
import deriveRuntimeEnvironment from '../utils/deriveRuntimeEnvironment.js';

const useRecaptcha = () => {
  const {
    RECAPTCHA_SITE_PUBLIC_KEY,
    RECAPTCHA_SITE_PUBLIC_KEY_PROD,
    RECAPTCHA_LIB_SRC_URL,
  } = config;

  const runtimeEnv = deriveRuntimeEnvironment();
  const recaptchaKey =
    runtimeEnv === 'production'
      ? RECAPTCHA_SITE_PUBLIC_KEY_PROD
      : RECAPTCHA_SITE_PUBLIC_KEY;

  const src = `${RECAPTCHA_LIB_SRC_URL}?render=${recaptchaKey}`;

  const [token, setToken] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 3;
  const RETRY_DELAY = 1000;

  const loadScript = () =>
    useScript(src, {
      removeOnUnmount: false,
    });

  const status = loadScript();

  const getRecaptchaToken = async () => {
    const token = await window.grecaptcha.enterprise.execute(recaptchaKey, {
      action: 'submit',
    });
    setToken(token);
  };

  useEffect(() => {
    if (status === 'ready') {
      window.grecaptcha.enterprise.ready(getRecaptchaToken);
    } else if (status === 'error' && retryCount < MAX_RETRIES) {
      setTimeout(() => {
        setRetryCount(retryCount + 1);
        loadScript(); // Retry loading the script
      }, RETRY_DELAY);
    }
  }, [status, retryCount]);

  return token;
};

export default useRecaptcha;
